import script from "./DescriptionPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./DescriptionPopover.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__